import { createAction } from '@reduxjs/toolkit';
import { api, handleApiErrors } from 'lib/src/utils/api';
import { AppDispatch } from 'src/redux/store';
import UserRoleResponse from 'src/types/shared/UserRoleResponse';

export const fetchChallengeHoldersForGroupRequest = createAction(
    'fetchChallengeHoldersForGroupRequest',
);
export const fetchChallengeHoldersForGroupSuccess = createAction<UserRoleResponse[]>(
    'fetchChallengeHoldersForGroupSuccess',
);
export const fetchChallengeHoldersForGroupFailure = createAction(
    'fetchChallengeHoldersForGroupFailure',
);

export const fetchChallengeHoldersForGroup = (id: number) => async (
    dispatch: AppDispatch,
): Promise<void> => {
    dispatch(fetchChallengeHoldersForGroupRequest());
    try {
        const {
            data: { users },
        } = await api.get<ChallengeHoldersResponseModel>(
            `admin/challengeGroups/${id}/attach-holder`,
        );

        dispatch(fetchChallengeHoldersForGroupSuccess(users));
    } catch (e) {
        handleApiErrors(dispatch, fetchChallengeHoldersForGroupFailure, e);
    }
};

interface ChallengeHoldersResponseModel {
    users: UserRoleResponse[];
}
